module.exports = __webpack_public_path__ + "static/media/Lesson-10-01-The-How-and-Why-be-ready-forJesus.ff6857bf.pdf";